export { config } from './app.mock';
